import { render, staticRenderFns } from "./deleteSentEmail.vue?vue&type=template&id=a0d3b480&"
import script from "./deleteSentEmail.vue?vue&type=script&lang=js&"
export * from "./deleteSentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports